import api from '../utils/api';

const LeadActions = {
  addMessage(params = {}) {
    return (dispatch) =>
      dispatch(api.users.leads.addMessage(params))
        .then((result) => {
          if (result.success) {
            return result.response;
          }
          return Promise.reject(result.error);
        })
        .catch((err) => new Error(err));
  },
};

export default LeadActions;
